import { useState } from 'react';
import { Box, Menu, MenuItem, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NavLink } from 'react-router-dom';
import { NavigationItemType } from 'framework/navigation';
import NavigationItemLabel from 'framework/ui/menu/NavigationItemLabel';
import { isHeaderMenuItemActive } from '../utils/headerMenuMatching';
import { Button } from 'framework/ui/mui-builder';

const GroupedHeaderMenuItem = ({ item, pathname }: { item: NavigationItemType; pathname: string }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const children = item.thirdLevelMenuChildren || [];
  const selected = children
    .filter(child => isHeaderMenuItemActive(child, pathname))
    .sort((a, b) => b.url.length - a.url.length)[0];
  const label = selected ? `${item.name} / ${selected.name}` : item.name;

  return (
    <>
      <Button
        variant="text"
        className={`header-menu__item-link ${selected ? 'active' : ''}`}
        data-text={label}
        data-testid={`desktop-menu-item-${item.name}`}
        aria-haspopup="menu"
        aria-expanded={Boolean(anchorEl)}
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography component="span" variant="body1" sx={{ whiteSpace: 'nowrap', display: 'flex', gap: 0.5 }}>
            {item.name}
            {selected && <span>/</span>}
            {selected && (
              <NavigationItemLabel
                name={`${selected.name}`}
                url={selected.url}
                isAlpha={selected.isAlpha}
                isBeta={selected.isBeta}
                color="text.secondary"
              />
            )}
          </Typography>
          <ExpandMoreIcon fontSize="small" />
        </Box>
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        {children.map(child => (
          <MenuItem
            key={`${child.url}-${child.name}`}
            component={NavLink}
            to={child.url}
            end={child.exact}
            selected={child === selected}
            onClick={() => setAnchorEl(null)}
          >
            <NavigationItemLabel name={child.name} url={child.url} isAlpha={child.isAlpha} isBeta={child.isBeta} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default GroupedHeaderMenuItem;
